<script lang="ts">
    import type {Employee} from "$lib/types/employee";
    import Reminder from "$items/employee/Reminder.svelte";
    import EmployeeInfo from "$items/employee/EmployeeInfo.svelte";
    import TaxAndInsurance from "$items/employee/TaxAndInsurance.svelte";
    import BankAccount from "$items/employee/BankAccount.svelte";
    import GeneralInfo from "$items/employee/GeneralInfo.svelte";
    import Photos from "$items/employee/Photos.svelte";
    import {getContext, onMount} from "svelte";
    import dayjs from "dayjs";
    import {asValue} from "$lib/utils/lenkradDate";
    import {Button, Textarea, Timeline, TimelineItem} from "flowbite-svelte";
    import {ExclamationCircleSolid, IconSolid, InfoCircleSolid} from "flowbite-svelte-icons";
    import Qualifications from "$items/employee/Qualifications.svelte";
    import type {Writable} from "svelte/store";
    import CardLayout from "$items/CardLayout.svelte";
    import {enhance} from "$app/forms";
    import EmployeeEmailStatusModal from "$lib/partials/employee/EmployeeEmailStatusModal.svelte";

    const ICONS = [
        {type: 'info', icon: InfoCircleSolid, color: 'bg-primary-200 text-primary-600'},
        {type: 'important', icon: ExclamationCircleSolid, color: 'bg-red-200 text-red-600'},
    ]
    let employee: Writable<Employee> = getContext('employee');
    const super_edit: Writable<boolean> = getContext('super_edit');

    let mailStatusModal = false;
    let mailId = null;
    onMount(() => {
        document.querySelectorAll('[data-type="mj-mail"]').forEach((item) => {
            item.addEventListener('click', ev =>{
                ev.preventDefault();
                mailId = item.getAttribute('data-message-id')
                mailStatusModal = true
                console.log({ev})
            })
        })
    })

</script>


<svelte:head>
    <title>{$employee.name} </title>
</svelte:head>

<div class="flex flex-col lg:flex-row gap-3">
    <div class="flex flex-col gap-7 xl:max-w-sm">
        <GeneralInfo employee={$employee}/>
        <CardLayout title={$employee.employmentStatus !== 'active' ? 'Ich will ins Team weil...' : 'Notiz'} className="sticky top-24">
            <Textarea disabled rows="4" value={$employee?.cv?.note}/>
        </CardLayout>
        <Photos employee={$employee}/>

    </div>

    <div class="flex flex-col 2xl:flex-row gap-3 w-full">
        <div class="flex flex-col w-full gap-7">
            <Reminder />
            <EmployeeInfo/>
            <Qualifications/>
            <TaxAndInsurance/>
            <BankAccount/>
        </div>

        <div class="max-w-sm w-full">
            <CardLayout display={false} className="mb-4" title="Add to Timeline" accordion>
                <form class="mb-7 flex flex-col gap-2" method="post" action="?/publish_to_timeline" use:enhance>
                    <Textarea id="textarea-id" placeholder="Your message" rows="4" name="content"/>
                    <Button type="submit" class="ml-auto" variant="primary">Add work log</Button>
                </form>
            </CardLayout>
            <div class="px-7 mt-8">
                <Timeline order="vertical" class="w-full">
                    {#each $employee.timeline.sort((a, b) => b.createdAt.stamp - a.createdAt.stamp) as timelineItem}
                        {@const icon = ICONS.find(x => x.type === timelineItem.type)}
                        <TimelineItem
                                title={timelineItem.type}
                                date={dayjs(asValue(timelineItem.createdAt)).format('DD.MM.YYYY HH:mm')}>
                            <svelte:fragment slot="icon">
                                <span class="flex absolute -left-3 justify-center items-center w-6 h-6 {icon?.color} rounded-full ring-8 ring-white">
                                    <IconSolid icon="{icon?.icon}"
                                               class="w-3 h-3 "/>
                                </span>
                            </svelte:fragment>
                            <p class="text-gray-400 my- text-xs">
                            {#if timelineItem.enteringEmployeeId}
                                {timelineItem?.enteringAssociations[0]?.firstName + ' ' + timelineItem?.enteringAssociations[0]?.lastName}
                            {:else}
                                System
                            {/if}
                            </p>
                            <div class="mb-4 text-base font-normal text-gray-500 overflow-x-auto">
                                {@html timelineItem.content}
                            </div>
                        </TimelineItem>

                    {/each}
                </Timeline>
            </div>

        </div>
    </div>

</div>
<EmployeeEmailStatusModal bind:open={mailStatusModal} {mailId}/>